module.exports = __webpack_public_path__ + "img/mwtjm1zU.22738730.png";